import { Link } from 'react-router-dom';

import { Logo, LogoIcon } from '@/components';
import { Route } from '@/constants';
import { cn } from '@/utils/styles';
import { SidebarHeader } from '@/components/ui/sidebar';

export type MainSidebarHeaderProps = {
  readonly isCollapsed: boolean;
  readonly className?: string;
  readonly homeHref?: string;
};

export function MainSidebarHeader({ isCollapsed, className, homeHref = Route.Home }: MainSidebarHeaderProps) {
  return (
    <SidebarHeader className={cn('p-4', isCollapsed && 'px-2', className)}>
      <Link to={homeHref} className="flex items-center justify-center">
        {isCollapsed ? (
          <LogoIcon color="white" className="h-5 w-auto" />
        ) : (
          <Logo color="white" className="h-7 w-auto" />
        )}
      </Link>
    </SidebarHeader>
  );
}
